import { ReactElement } from "react";

export default function CompensationHistory(): ReactElement {
  return <div>Compensation History</div>;
}
